import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { ArrowDownIcon } from '@deliveryhero/armor-icons';
import { paddingAttributes } from '../../../system/attributes';
import { makePropList, getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { TableCell } from '../TableCell';
import { color, spacing } from '../../../system/mixins';
import { transition } from '../../../system/mixins/transition';
import { expansion } from '../../../system/mixins/expansion';
var propertyList = makePropList(['expanded']);
export var TableControllerCellRoot = styled(TableCell).withConfig(getPropsBlocker(propertyList, false))(_templateObject(), spacing(4), spacing(4), spacing(2.5), getComponentOverride('TableControllerCell'), paddingAttributes);
export var TableControllerCellContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2());
export var TableControllerCellIcon = styled(ArrowDownIcon).withConfig(getPropsBlocker({}, false))(_templateObject3(), color('primary.main'), transition({
  transform: true
}), expansion(180));